import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { DesignMagazineHotelArticleI18nEditPresenter } from "./presenter";
import { useHotelI18nArticleQuery } from "../../model/repository/query/use-hotel-i18n-query";

type Props = {
	hotelID: string;
	langCode: LangCode;
};

export const DesignMagazineHotelArticleI18nEditContainer = memo(({ hotelID, langCode }: Props) => {
	const { data } = useHotelI18nArticleQuery({ hotelID, langCode });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignMagazineHotelArticleI18nEditPresenter hotelID={hotelID} langCode={langCode} data={data} />;
});

DesignMagazineHotelArticleI18nEditContainer.displayName = "DesignMagazineHotelArticleI18nEditContainer";
